import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="bg-slate-950 text-slate-400 pt-16 pb-8 border-t border-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img 
                src="/assets/footer-logo-new.png" 
                alt="EnergiPro Solutions" 
                className="h-20 w-auto object-contain" 
              />
            </div>
            <p className="mb-4 text-sm leading-relaxed">
              Integrated Oilfield Equipment & Field Support Provider — delivering well testing spreads, stimulation equipment, chemicals, and operational logistics across KSA, UAE & Egypt.
            </p>
            <div className="flex gap-2 flex-wrap">
              <span className="bg-slate-900 text-slate-400 text-[10px] px-2 py-1 rounded uppercase font-bold">Saudi Arabia</span>
              <span className="bg-slate-900 text-slate-400 text-[10px] px-2 py-1 rounded uppercase font-bold">UAE</span>
              <span className="bg-slate-900 text-slate-400 text-[10px] px-2 py-1 rounded uppercase font-bold">Egypt</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6 uppercase tracking-wider">Quick Links</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-orange-500 transition-colors">Home</Link></li>
              <li><Link to="/about" className="hover:text-orange-500 transition-colors">About Us</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Services & Equipment</Link></li>
              <li><Link to="/safety" className="hover:text-orange-500 transition-colors">HSE Policy</Link></li>
              <li><Link to="/projects" className="hover:text-orange-500 transition-colors">Projects</Link></li>
              <li><Link to="/contact" className="hover:text-orange-500 transition-colors">Contact</Link></li>
              <li><Link to="/portal" className="hover:text-orange-500 transition-colors flex items-center gap-1">Client Portal <span className="text-[9px] bg-orange-500/20 text-orange-400 px-1.5 py-0.5 rounded uppercase font-bold">Secure</span></Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6 uppercase tracking-wider">Services</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Surface Well Testing Equipment</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Stimulation & Nitrogen Equipment</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Field Services & Ops Support</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Heavy & Light Equipment Rental</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Filtration & Water Treatment</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Oilfield Chemicals Supply</Link></li>
              <li><Link to="/services" className="hover:text-orange-500 transition-colors">Logistics & Transportation</Link></li>
            </ul>
          </div>

          {/* Group Companies */}
          <div>
            <h3 className="text-white font-bold text-lg mb-6 uppercase tracking-wider">Group Companies</h3>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="hover:text-orange-500 transition-colors">EnergiPro Solutions — Saudi Arabia</Link></li>
              <li><Link to="/companies/kimko" className="hover:text-orange-500 transition-colors">KIMKO — United Arab Emirates</Link></li>
              <li><Link to="/companies/petronix" className="hover:text-orange-500 transition-colors">Petronix Energy Services — Egypt</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="lg:col-span-4">
            <h3 className="text-white font-bold text-lg mb-6 uppercase tracking-wider">Contact Us</h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {/* EnergiPro Solutions */}
              <div className="border-l-2 border-orange-500 pl-4">
                <span className="text-orange-500 font-bold text-xs uppercase tracking-wider">KSA</span>
                <h4 className="font-bold text-white mt-2">EnergiPro Solutions</h4>
                <p className="text-slate-400 text-sm mt-1">Al Khobar, Eastern Province</p>
                <a href="mailto:md@energiprogroup.com" className="text-slate-300 hover:text-orange-400 text-sm block mt-2 transition-colors">md@energiprogroup.com</a>
                <a href="tel:+966133308579" className="text-slate-300 hover:text-orange-400 text-sm block transition-colors">+966 13 330 8579</a>
                <Link to="/" className="text-orange-400 hover:text-orange-300 text-sm block mt-2 transition-colors">energiprogroup.com →</Link>
              </div>
              {/* KIMKO */}
              <div className="border-l-2 border-orange-500 pl-4">
                <span className="text-orange-500 font-bold text-xs uppercase tracking-wider">UAE</span>
                <h4 className="font-bold text-white mt-2">KIMKO Electromechanical</h4>
                <p className="text-slate-400 text-sm mt-1">Dubai, UAE</p>
                <a href="mailto:gm@kimkocorp.com" className="text-slate-300 hover:text-orange-400 text-sm block mt-2 transition-colors">gm@kimkocorp.com</a>
                <a href="tel:+971555412039" className="text-slate-300 hover:text-orange-400 text-sm block transition-colors">+971 555 412 039</a>
                <Link to="/companies/kimko" className="text-orange-400 hover:text-orange-300 text-sm block mt-2 transition-colors">kimkomep.com →</Link>
              </div>
              {/* Petronix */}
              <div className="border-l-2 border-orange-500 pl-4">
                <span className="text-orange-500 font-bold text-xs uppercase tracking-wider">Egypt</span>
                <h4 className="font-bold text-white mt-2">Petronix Energy Services</h4>
                <p className="text-slate-400 text-sm mt-1">Cairo, Egypt</p>
                <a href="mailto:gm@petronix-eg.com" className="text-slate-300 hover:text-orange-400 text-sm block mt-2 transition-colors">gm@petronix-eg.com</a>
                <a href="tel:+201156969766" className="text-slate-300 hover:text-orange-400 text-sm block transition-colors">+20 115 696 9766</a>
                <Link to="/companies/petronix" className="text-orange-400 hover:text-orange-300 text-sm block mt-2 transition-colors">petronix-eg.com →</Link>
              </div>
            </div>
          </div>
        </div>

        {/* Data Security Statement */}
        <div className="border-t border-slate-900 pt-8 mb-8">
          <div className="flex items-center justify-center gap-2 mb-3">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5 text-green-500"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>
            <span className="text-slate-400 text-[10px] uppercase tracking-wider font-bold">Data Security & Privacy</span>
          </div>
          <p className="text-slate-500 text-[10px] text-center max-w-2xl mx-auto leading-relaxed">
            All client data is encrypted in transit and at rest. Our systems implement role-based access controls, session management with auto-expiry, and data isolation between client accounts. Access to client information is restricted to verified personnel only. EnergiPro Solutions maintains information security practices aligned with ISO 27001 principles.
          </p>
        </div>

        {/* Management Systems Alignment */}
        <div className="border-t border-slate-900 pt-8 mb-8">
          <div className="flex flex-wrap justify-center gap-8">
            <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-sm border border-green-800">
              <span className="text-green-400 font-bold text-sm">ISO 9001</span>
              <span className="text-slate-400 text-xs">Quality — Certified ✓</span>
            </div>
            <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-sm border border-green-800">
              <span className="text-green-400 font-bold text-sm">ISO 14001</span>
              <span className="text-slate-400 text-xs">Environmental — Certified ✓</span>
            </div>
            <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-sm border border-green-800">
              <span className="text-green-400 font-bold text-sm">ISO 45001</span>
              <span className="text-slate-400 text-xs">Health & Safety — Certified ✓</span>
            </div>
            <div className="flex items-center gap-2 bg-slate-900 px-4 py-2 rounded-sm">
              <span className="text-orange-500 font-bold text-sm">API</span>
              <span className="text-slate-500 text-xs">Principles Applied</span>
            </div>
          </div>
        </div>

        <div className="border-t border-slate-900 pt-8 flex flex-col md:flex-row justify-between items-center text-xs">
          <p>&copy; {new Date().getFullYear()} EnergiPro Solutions. All rights reserved.</p>
          <div className="flex space-x-6 mt-4 md:mt-0">
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms of Service</Link>
            <Link to="/sitemap" className="hover:text-white">Sitemap</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
